module.exports = __webpack_public_path__ + "img/top202509.5cfc7312.png";